import { useState, useEffect, useCallback } from "react";
import { clearAuthData } from "../utils/authUtils";

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  const checkAuth = useCallback(() => {
    const authStatus = localStorage.getItem("isAuthenticated") === "true";
    const token = localStorage.getItem("token");
    // User is authenticated if both authStatus and token exist
    setIsAuthenticated(authStatus && !!token);
  }, []);

  // Clear auth function that can be called externally
  const clearAuth = useCallback(() => {
    clearAuthData();
    setIsAuthenticated(false);
  }, []);

  useEffect(() => {
    checkAuth();

    // Listen for storage changes (for logout in other tabs and token expiration)
    const handleStorageChange = (e: StorageEvent) => {
      // Only react to auth-related changes
      if (e.key === 'isAuthenticated' || e.key === 'token') {
        checkAuth();
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [checkAuth]);

  return { isAuthenticated, clearAuth };
}; 